import { useTranslation } from "react-i18next";
import { getColor } from "../../../../pages/postEditor/seoAnalyzer/helper";

export const UrlAnalysis = ({ analysis }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Score Bar */}
       <div className="mt-4">
                        <span className="font-semibold mb-3">
                          {analysis.total_score}%
                          </span>
                          </div>
                        
                        <div className="w-full relative p-2 rounded-xl bg-slate-300 mb-5 mt-1">
                          <div
                            className={`bg-${getColor(
                              analysis.total_score
                            )} h-full rounded-xl absolute top-0 left-0`}
                            style={{ width: `${analysis.total_score}%` }}
                          ></div>
                        </div>

      {/* Target Keyword Included */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Target-Keyword-Included", "Target Keyword Included")}
        </p>
        <p
          className={`${
            analysis?.keyword_score == 100
              ? "text-green-500"
              : analysis?.keyword_score < 100 && analysis?.keyword_score > 0
              ? "text-yellow-400"
              : analysis?.keyword_score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.keyword_score == 100
            ? t(
                "Target-keyword-included-in-url",
                "The target request is fully included in the url."
              )
            : analysis?.keyword_score < 100 && analysis?.keyword_score > 0
            ? t(
                "Some-of-target-keywords-are-included-in-url",
                "Some of the target keywords are included in the url."
              )
            : analysis?.keyword_score == 0
            ? ("None-of-target-keyword-included-in-url",
              "None of target keyword is included in url")
            : t("Please-add-Slug-URL", "Please add a URL slug")}
        </p>
      </div>

      {/* Length Check */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">{t("Length", "Length")} </p>
        <p
          className={`${
            analysis?.url_length.score > 70
              ? "text-green-500"
              : analysis?.url_length.score >= 35
              ? "text-yellow-400"
              : analysis?.url_length.score >= 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.url_length.score == -1 ? (
            <>
              {t(
                "Please-add-URL-slug-and-URL-path",
                "Please add a URL slug and a URL path"
              )}
            </>
          ) : (
            <>
              {`${t("Your-URL-slug-contains", "Your URL slug contains")} ${
                analysis?.url_length.urlSlugLength
              } ${t("word", "word")}${
                analysis?.url_length.urlSlugLength > 1 ? t("s", "s") : ""
              } (${analysis?.url_length.completeUrlLength} ${t(
                "characters",
                "characters"
              )}).`}
            </>
          )}
        </p>
      </div>

      {/* Special Character and Seperators */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t(
            "Special-Character-and-Seperators",
            "Special-Character-and-Seperators"
          )}{" "}
        </p>
        <p
          className={`${
            analysis?.seperator_check == 100
              ? "text-green-500"
              : analysis?.seperator_check == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.seperator_check == 100 && (
            <>
              {t(
                "Your-slug-uses-hyphens-to-seperate-words-and-not-other-special-characters.Perfect!",
                "Your slug uses hyphens to seperate words and not other special characters. Perfect!"
              )}
            </>
          )}{" "}
          {analysis?.seperator_check == 0 && (
            <>
              {t(
                "Your-slug-contains-special-characters",
                "Your slug contains special characters"
              )}
            </>
          )}{" "}
          {analysis?.seperator_check == -1 && (
            <>{t("Please-add-Slug-d'URL", "Please add Slug d'URL")}</>
          )}
        </p>
      </div>

      {/* Url Depth */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("URL-Depth", "URL Depth")}{" "}
        </p>
        <p
          className={`${
            analysis?.url_depth?.score == 100
              ? "text-green-500"
              : analysis?.url_depth?.score == 50
              ? "text-yellow-400"
              : analysis?.url_depth?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.url_depth?.score == 100
            ? `${t(
                "Your-URL-depth-is-perfect-(",
                "Your URL depth is perfect ("
              )}${analysis?.url_depth.value} ${t("parts", "part")}${
                analysis?.url_depth.value > 1 ? "s)." : ")."
              }`
            : analysis?.url_depth?.score == 50
            ? `${t(
                "Your-URL-depth-is-more-than-optimal-depth-(",
                "Your URL depth is more than optimal depth ("
              )}${analysis?.url_depth.value} ${t("parts", "part")}${
                analysis?.url_depth.value > 1 ? "s)." : ")."
              }.`
            : analysis?.url_depth?.score == 0
            ? `${t(
                "Your-URL-depth-is-far-away-from-optimal-depth",
                "Your URL depth is far away from optimal depth"
              )} (${analysis?.url_depth.value} ${t("parts", "part")}${
                analysis?.url_depth.value > 1 ? "s)." : ")."
              }.`
            : t("Please-add-Path-URL", "Please add a URL path")}
        </p>
      </div>

      {/* Lowecase Check */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Lowercase", "Lowercase")}{" "}
        </p>
        <p
          className={`${
            analysis?.lowerCase_check?.score == 100
              ? "text-green-500"
              : analysis?.lowerCase_check?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.lowerCase_check?.score == 100 && (
            <>
              {t(
                "You-slug-consists-of-only-lowercase-letters.It's-ideal!",
                "You slug consists of only lowercase letters. It's ideal!"
              )}
            </>
          )}{" "}
          {analysis?.lowerCase_check?.score == 0 && (
            <>
              {`${t("You-slug=consists-of", "You slug consists of ")}${
                analysis?.lowerCase_check.letterLength
              } ${t("uppercase-letters", "uppercase letters")}.`}
            </>
          )}
          {analysis?.lowerCase_check?.score == -1 && (
            <>{t("Please-add-Slug-d'URL", "Please add Slug d'URL")}</>
          )}
        </p>
      </div>
    </>
  );
};
